import { Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { view as view_1, update as update_1, init as init_1, Model_$reflection as Model_$reflection_1, Msg_$reflection as Msg_$reflection_1 } from "./AdminTeams.fs.js";
import { view as view_2, update as update_2, init as init_2, Model_$reflection as Model_$reflection_2, Msg_$reflection as Msg_$reflection_2 } from "./AdminCP.fs.js";
import { view as view_3, update as update_3, init as init_3, Model_$reflection as Model_$reflection_3, Msg_$reflection as Msg_$reflection_3 } from "./AdminAnswers.fs.js";
import { view as view_4, update as update_4, init as init_4, Model_$reflection as Model_$reflection_4, Msg_$reflection as Msg_$reflection_4 } from "./AdminResults.fs.js";
import { union_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { Navigation_modifyUrl } from "./fable_modules/Fable.Elmish.Browser.4.1.0/navigation.fs.js";
import { noCmd, Infra_getUrlHashParts, Infra_urlWithNewHash } from "./Common.fs.js";
import { Cmd_map, Cmd_batch, Cmd_none } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ofArray, singleton } from "./fable_modules/fable-library.4.10.0/List.js";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { singleton as singleton_1, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { Infra_defaultMediaImg, Infra_urlForMediaOrDefault } from "../shared/Shared.fs.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SwitchToTeams", "Teams", "SwitchToCP", "CP", "SwitchToAnswers", "Answers", "SwitchToResults", "Results"];
    }
}

export function Msg_$reflection() {
    return union_type("Admin.Msg", [], Msg, () => [[], [["Item", Msg_$reflection_1()]], [], [["Item", Msg_$reflection_2()]], [], [["Item", Msg_$reflection_3()]], [], [["Item", Msg_$reflection_4()]]]);
}

export class Model extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "Teams", "CP", "Answers", "Results"];
    }
}

export function Model_$reflection() {
    return union_type("Admin.Model", [], Model, () => [[], [["Item", Model_$reflection_1()]], [["Item", Model_$reflection_2()]], [["Item", Model_$reflection_3()]], [["Item", Model_$reflection_4()]]]);
}

export function replaceHashCmd(msg) {
    switch (msg.tag) {
        case 0:
            return Navigation_modifyUrl(Infra_urlWithNewHash("#teams"));
        case 2:
            return Navigation_modifyUrl(Infra_urlWithNewHash("#cp"));
        case 4:
            return Navigation_modifyUrl(Infra_urlWithNewHash("#answers"));
        case 6:
            return Navigation_modifyUrl(Infra_urlWithNewHash("#results"));
        default:
            return Cmd_none();
    }
}

export function switchByHashMsg() {
    const hashTag = Infra_getUrlHashParts()[0];
    switch (hashTag) {
        case "#teams":
            return new Msg(0, []);
        case "#cp":
            return new Msg(2, []);
        case "#answers":
            return new Msg(4, []);
        case "#results":
            return new Msg(6, []);
        default:
            return new Msg(0, []);
    }
}

export function init(api, user) {
    let msg;
    return [new Model(0, []), (msg = switchByHashMsg(), singleton((dispatch) => {
        dispatch(msg);
    }))];
}

export function update(api, user, msg, cm) {
    let matchResult, subModel_1, subMsg, subModel_4, subMsg_1, subModel_7, subMsg_2, subModel_10, subMsg_3;
    switch (msg.tag) {
        case 1: {
            if (cm.tag === 1) {
                matchResult = 1;
                subModel_1 = cm.fields[0];
                subMsg = msg.fields[0];
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 2: {
            matchResult = 2;
            break;
        }
        case 3: {
            if (cm.tag === 2) {
                matchResult = 3;
                subModel_4 = cm.fields[0];
                subMsg_1 = msg.fields[0];
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 4: {
            matchResult = 4;
            break;
        }
        case 5: {
            if (cm.tag === 3) {
                matchResult = 5;
                subModel_7 = cm.fields[0];
                subMsg_2 = msg.fields[0];
            }
            else {
                matchResult = 8;
            }
            break;
        }
        case 6: {
            matchResult = 6;
            break;
        }
        case 7: {
            if (cm.tag === 4) {
                matchResult = 7;
                subModel_10 = cm.fields[0];
                subMsg_3 = msg.fields[0];
            }
            else {
                matchResult = 8;
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            const patternInput = init_1(api, user);
            return [new Model(1, [patternInput[0]]), Cmd_batch(ofArray([Cmd_map((Item) => (new Msg(1, [Item])), patternInput[1]), replaceHashCmd(msg)]))];
        }
        case 1: {
            const patternInput_1 = update_1(api, user, subMsg, subModel_1);
            return [new Model(1, [patternInput_1[0]]), Cmd_map((Item_1) => (new Msg(1, [Item_1])), patternInput_1[1])];
        }
        case 2: {
            const patternInput_2 = init_2(api, user);
            return [new Model(2, [patternInput_2[0]]), Cmd_batch(ofArray([Cmd_map((Item_2) => (new Msg(3, [Item_2])), patternInput_2[1]), replaceHashCmd(msg)]))];
        }
        case 3: {
            const patternInput_3 = update_2(api, user, subMsg_1, subModel_4);
            return [new Model(2, [patternInput_3[0]]), Cmd_map((Item_3) => (new Msg(3, [Item_3])), patternInput_3[1])];
        }
        case 4: {
            const patternInput_4 = init_3(api, user);
            return [new Model(3, [patternInput_4[0]]), Cmd_batch(ofArray([Cmd_map((Item_4) => (new Msg(5, [Item_4])), patternInput_4[1]), replaceHashCmd(msg)]))];
        }
        case 5: {
            const patternInput_5 = update_3(api, user, subMsg_2, subModel_7);
            return [new Model(3, [patternInput_5[0]]), Cmd_map((Item_5) => (new Msg(5, [Item_5])), patternInput_5[1])];
        }
        case 6: {
            const patternInput_6 = init_4(api, user);
            return [new Model(4, [patternInput_6[0]]), Cmd_batch(ofArray([Cmd_map((Item_6) => (new Msg(7, [Item_6])), patternInput_6[1]), replaceHashCmd(msg)]))];
        }
        case 7: {
            const patternInput_7 = update_4(api, user, subMsg_3, subModel_10);
            return [new Model(4, [patternInput_7[0]]), Cmd_map((Item_7) => (new Msg(7, [Item_7])), patternInput_7[1])];
        }
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, settings, model) {
    let children_20, children_18, children_16, children_4, props_4, children_2, props_8, props_10, props_12, props_14, props_16, children_24, props_24, children_22, children_38, props_38, children_36;
    const children_40 = [(children_20 = [(children_18 = [(children_16 = [(children_4 = [(props_4 = [new HTMLAttr(65, ["navbar-item"]), ["style", {
        marginRight: "auto",
    }]], (children_2 = toList(delay(() => {
        let children, props;
        return singleton_1((children = [(props = [new HTMLAttr(149, [Infra_urlForMediaOrDefault(settings.MediaHost, user.QuizImg, Infra_defaultMediaImg)]), new HTMLAttr(8, ["logo"]), ["style", {
            height: "64px",
            width: "64px",
            maxHeight: "64px",
        }]], react.createElement("img", keyValueList(props, 1)))], react.createElement("figure", {
            className: "image is-64x64",
        }, ...children)));
    })), react.createElement("a", keyValueList(props_4, 1), ...children_2)))], react.createElement("div", {
        className: "navbar-brand",
    }, ...children_4)), (props_8 = [new HTMLAttr(65, ["title is-4 is-paddingleft"]), ["style", {
        maxWidth: "320px",
    }]], react.createElement("h4", keyValueList(props_8, 1), user.QuizName)), (props_10 = [Helpers_classList([["navbar-item", true], ["has-text-weight-bold", model.tag === 1]]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(0, []));
    }])], react.createElement("a", keyValueList(props_10, 1), "Teams")), (props_12 = [Helpers_classList([["navbar-item", true], ["has-text-weight-bold", model.tag === 2]]), new DOMAttr(40, [(_arg_1) => {
        dispatch(new Msg(2, []));
    }])], react.createElement("a", keyValueList(props_12, 1), "Control Panel")), (props_14 = [Helpers_classList([["navbar-item", true], ["has-text-weight-bold", model.tag === 3]]), new DOMAttr(40, [(_arg_2) => {
        dispatch(new Msg(4, []));
    }])], react.createElement("a", keyValueList(props_14, 1), "Answers")), (props_16 = [Helpers_classList([["navbar-item", true], ["has-text-weight-bold", model.tag === 4]]), new DOMAttr(40, [(_arg_3) => {
        dispatch(new Msg(6, []));
    }])], react.createElement("a", keyValueList(props_16, 1), "Results"))], react.createElement("nav", {
        className: "navbar is-transparent is-spaced",
        role: "navigation",
        "aria-label": "dropdown navigation",
    }, ...children_16))], react.createElement("div", {
        className: "container",
    }, ...children_18))], react.createElement("div", {
        className: "hero-head",
    }, ...children_20)), (children_24 = [(props_24 = [new HTMLAttr(65, ["container"]), ["style", {
        marginBottom: "auto",
    }]], (children_22 = toList(delay(() => ((model.tag === 1) ? singleton_1(view_1((arg) => {
        dispatch(new Msg(1, [arg]));
    }, user, model.fields[0])) : ((model.tag === 2) ? singleton_1(view_2((arg_1) => {
        dispatch(new Msg(3, [arg_1]));
    }, user, settings, model.fields[0])) : ((model.tag === 3) ? singleton_1(view_3((arg_2) => {
        dispatch(new Msg(5, [arg_2]));
    }, user, model.fields[0])) : ((model.tag === 4) ? singleton_1(view_4((arg_3) => {
        dispatch(new Msg(7, [arg_3]));
    }, user, model.fields[0], settings.MediaHost)) : singleton_1("empty"))))))), react.createElement("div", keyValueList(props_24, 1), ...children_22)))], react.createElement("div", {
        className: "hero-body",
    }, ...children_24)), (children_38 = [(props_38 = [new HTMLAttr(65, ["container"]), ["style", {
        textAlign: "center",
    }]], (children_36 = ["©", react.createElement("span", {
        className: "is-hidden-touch",
    }, " Serhii Sabirov"), " 2020/25", " - ", react.createElement("a", {
        href: "/terms.html",
        className: "has-text-grey-light",
    }, "Terms"), " - ", react.createElement("a", {
        href: "/disclaimer.html",
        className: "has-text-grey-light",
    }, "Disclaimer"), " - ", react.createElement("a", {
        href: "/privacy-policy-en.html",
        className: "has-text-grey-light",
    }, "Privacy"), " - ", react.createElement("a", {
        href: "https://t.me/open_quiz",
        className: "has-text-grey-light",
    }, "Contact")], react.createElement("div", keyValueList(props_38, 1), ...children_36)))], react.createElement("div", {
        className: "hero-foot has-background-dark has-text-grey-light",
    }, ...children_38))];
    return react.createElement("section", {
        className: "hero is-shadowless is-fullheight is-light",
    }, ...children_40);
}

